import React, { memo } from 'react';
import PropTypes from 'prop-types';
import compose from '@nubank/nuds-web/utils/functional/compose';

import websitePage, { headerTypes, footerTypes } from 'hoc/websitePage/websitePage';
import { MULTI_PRODUCT } from 'utils/prospectTypes';
import SectionLearnMore from 'patterns/SectionLearnMore/SectionLearnMore';
import SectionFees from 'patterns/SectionFees/SectionFees';

import SectionForm from './patterns/SectionForm/SectionForm';
import SectionTransfer from './patterns/SectionTransfer/SectionTransfer';
import SectionBucket from './patterns/SectionBucket/SectionBucket';
import SectionApp from './patterns/SectionApp/SectionApp';
import SectionCustomerService from './patterns/SectionCustomerService/SectionCustomerService';
import SectionCard from './patterns/SectionCard/SectionCard';
import { StyledTitleTypography, StyledSubtitleTypography } from './styles/Typography';

const NEWS = [
  'CALENDAR',
  'TUTORIAL',
  'FGTS',
];

function FGTSPage({ onFormVisibilityChange }) {
  return (
    <>
      <SectionForm onFormVisibilityChange={onFormVisibilityChange} />
      <SectionTransfer />
      <SectionBucket />
      <SectionCard />
      <SectionFees>
        <StyledTitleTypography
          intlKey="FGTS.FEES.TITLE"
          variant="title"
          gutterBottom={1}
        />
        <StyledSubtitleTypography
          intlKey="FGTS.FEES.SUBTITLE"
          variant="subtitle"
        />
      </SectionFees>
      <SectionApp />
      <SectionCustomerService />
      <SectionLearnMore
        content={NEWS}
        prefix="FGTS.LINKS"
        imagePath="purple-man/purple-man"
      />
    </>
  );
}

FGTSPage.propTypes = {
  onFormVisibilityChange: PropTypes.func.isRequired,
};

export default compose(
  websitePage({
    routeKey: 'FGTS',
    footer: footerTypes.COMPANY_INFO,
    header: headerTypes.FEATURE_PAGE,
    widgetProspectType: MULTI_PRODUCT,
  }),
  memo,
)(FGTSPage);
